import React from "react";
import {
  Box,
  Button,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

// import image2 from "../../../../Images/IPB/image2.png";
// import image3 from "../../../../Images/IPB/image3.png";
// import image4 from "../../../../Images/IPB/image4.png";
// import image5 from "../../../../Images/IPB/image5.png";
// import image6 from "../../../../Images/IPB/image6.png";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { Done } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const IPB = () => {
  const navigate = useNavigate();
  return (
    <Grid2 container spacing={"2rem"}>
      <WaveBackground
        menu={"Our Products"}
        title={"Internet Booking Platform"}
        description={
          "EBook Services And Events Easily With One Powerful Platform"
        }
      />

      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
          mt="-10%"
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/IPB/image3.png"}
              alt="Internet Booking Platform screenshot"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                textAlign: { xs: "center", md: "left" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Internet Booking Platform Web App
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              A{" "}
              <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                Internet Booking Platform{" "}
              </span>{" "}
              is a comprehensive online solution designed to simplify the
              process of booking various services through a unified,
              user-friendly platform. Whether it’s reserving accommodations,
              booking appointments, purchasing event tickets, or scheduling
              services, this platform aims to provide a seamless and efficient
              experience for users and service providers alike.
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 700,
                fontFamily: "inherit",
                mt: 4,
              }}
            >
              Key Features
            </Typography>
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>User Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText> Service Listings</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Booking and Reservations</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Payment Processing</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Search and Filtering</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Admin and Provider Dashboard</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent={"center"}
        sx={{ background: commonCss.backgroundGray }}
      >
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", md: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pl: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              We use an Internet Booking Platform (IBP) system because it
              provides a streamlined and efficient way to manage bookings and
              reservations online
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              Why Use an IBP?
            </Typography>

            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 4,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Customers can book anytime from anywhere, increasing
                  convenience and customer satisfaction.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Instantly updates availability and prevents double bookings.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Reduces manual work with automated confirmations, reminders,
                  and payments.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Easy-to-use interfaces and quick booking processes improve
                  user satisfaction.
                </ListItemText>
              </ListItem>
            </List>
          </Grid2>
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-end" }}
          >
            <img
              src={"/Images/IPB/image4.png"}
              alt="Internet Booking Platform screenshot"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/IPB/image5.png"}
              alt="Internet Booking Platform screenshot"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Benefits
            </Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1.1rem",
                  fontWeight: 400,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Enhanced user experience through intuitive navigation and fast
                  booking.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Real-time updates to prevent double bookings and maintain
                  accuracy.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Increased business visibility for service providers through a
                  centralized platform.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Reduced booking errors and improved customer satisfaction.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Interactive dashboards</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent={"center"}
        sx={{ background: commonCss.backgroundGray }}
      >
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "2rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pl: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Space Management Features
            </Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1.1rem",
                  fontWeight: 400,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Space Allocation & Leasing.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Space Utilization Analytics.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Maintenance & Service Requests.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Revenue and Payment Management.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Tenant Communication Hub.</ListItemText>
              </ListItem>
            </List>
          </Grid2>

          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-end" }}
          >
            <img
              src={"/Images/IPB/image6.png"}
              alt="Internet Booking Platform screenshot"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
            maxWidth: { xs: "auto", md: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/IPB/image2.png"}
              alt="Internet Booking Platform screenshot"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Advertisement Management Features
            </Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1.1rem",
                  fontWeight: 400,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Ad Space Inventory Management.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Ad Campaign Management.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Advertising Analytics.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Multi-Channel Ad Management.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Advertiser Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Multi-Tenant Ad Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Ad Compliance & Approval Workflow</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        size={12}
        container
        justifyContent={"flex-end"}
        sx={{ p: "0rem 2rem 2rem 0rem", width: { xs: "auto", xl: "2000px" } }}
      >
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            //  position: 'relative',
            //   transition: '0.3s',
            //     animation: 'glow 1.5s infinite alternate',

            //   '@keyframes glow': {
            //     '0%': {
            //       background: "#FCAE1E",
            //     },
            //     '100%': {
            //       background: commonCss.blue,
            //     },
            //   },
          }}
          onClick={() => {
            navigate("/products?productName=ibp");
          }}
        >
          Explore More Products
        </Button>
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            position: "relative",
            transition: "0.3s",
            animation: "glow 1.5s infinite alternate",

            "@keyframes glow": {
              "0%": {
                background: "#FCAE1E",
              },
              "100%": {
                background: commonCss.blue,
              },
            },
          }}
          onClick={() => {
            navigate(
              "/contactus?type=Product Demo&&demo=Internet Booking Platform"
            );
          }}
        >
          Schedule a Demo
        </Button>
      </Grid2>
    </Grid2>
  );
};

export default IPB;
